import React from 'react';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import IconButton from '@material-ui/core/IconButton';
import QualitySelector from './QualitySelector';
import AudioSelector from './AudioSelector';
import SubtitleSelector from './SubtitleSelector';
import PlaybackRateSelector from './PlaybackRateSelector';

class VideoControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      muted: false,
      isMenuOpen: false
    };
  }
  handleMuteButtonClick = (e) => {
    e.preventDefault();
    const video = document.getElementById('video');
    video.muted = !video.muted;
    this.setState({ muted: video.muted });
  };
  handleFullscreenButtonClick = (e) => {
    e.preventDefault();
    const video = document.getElementById('mainContainer');
    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };
  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  }
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    if (!this.state.isMenuOpen) {
      this.props.onOverlayFixed(false);
    }
  }
  onOpenMenu = (open) => {
    this.setState({ isMenuOpen: open });
  }
  render = () => {
    const overlay = this.props.overlay;
    if (!overlay) {
      return (<div/>);
    }
    const style={color:'white'};
    return (
      <div
        id="video-controls"
        style={{position: 'absolute', right: '8px', bottom: '22px'}}
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
        onMouseLeave={this.handleMouseLeave}
      >
        <PlaybackRateSelector
          {...this.props}
          onOpenMenu={this.onOpenMenu}
        />
        <SubtitleSelector
          {...this.props}
          onOpenMenu={this.onOpenMenu}
        />
        <QualitySelector
          {...this.props}
          onOpenMenu={this.onOpenMenu}
        />
        <AudioSelector
          {...this.props}
          onOpenMenu={this.onOpenMenu}
        />
        <IconButton style={style} onClick={this.handleMuteButtonClick}>
          {this.state.muted ? <VolumeOffIcon/> : <VolumeUpIcon/>}
        </IconButton>
        <IconButton style={style} onClick={this.handleFullscreenButtonClick}>
          {this.props.isFullscreen ? <FullscreenExitIcon/> : <FullscreenIcon/>}
        </IconButton>
      </div>
    );
  }
};
export default VideoControls;



// WEBPACK FOOTER //
// ./src/components/VideoControls.js